import React from 'react'
import styles from './operation.scss'
import operation from '../../../common/images/solution/operation.jpg'
import yd_operation from '../../../common/images/solution/yd-operation.png'
import one from '../../../common/images/solution/01.png'
import two from '../../../common/images/solution/02.png'
import three from '../../../common/images/solution/03.png'
import four from '../../../common/images/solution/04.png'
import circular from '../../../common/images/solution/circular.png'
import solutions from '../../../common/images/solution/solution.png'
import operation_1 from '../../../common/images/solution/operation-1.jpg'
import operation_2 from '../../../common/images/solution/operation-2.jpg'
import operation_3 from '../../../common/images/solution/operation-3.jpg'
import operation_4 from '../../../common/images/solution/operation-4.jpg'
import one_x from '../../../common/images/solution/01-x.png'
import two_x from '../../../common/images/solution/02-x.png'
import three_x from '../../../common/images/solution/03-x.png'
import fous_x from '../../../common/images/solution/04-x.png'

const Operation = (props) => {
  return <section className={styles['operation']}>
    <div className={styles['bill']}>
      <img src={operation} alt='operation' className={styles['bill_img']} />
      <img src={yd_operation} alt='yd_operation' className={styles['bg_bill_img']} />
      <div className={styles['bill-content']}>
        <h2>运营管理</h2>
        <p>建新账，清旧账，理乱账，定制专属财税方案。</p>
      </div>
    </div>
    <div className={styles['industry-pain']}>
      <h3>行业痛点</h3>
      <ul>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={one} alt='01' className={styles['industry-one']} /></div>
            <h4>客户管理难</h4>
          </div>
          <div className={styles['industry-p']}>
            <span></span>
            <p>
            客户资料杂乱无章，不易查询；员工离职带走客户，没有保留资料，客户流失严重。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={two} alt='02' /></div>
            <h4>服务跟进不及时</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s2']}></span>
            <p>
            信息获取速度慢、渠道少，不能及时跟进财税服务、工商服务情况。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={three} alt='03' /></div>
            <h4>合同资料难理清</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s3']}></span>
            <p>
            客户合同翻找难，查找慢，合同签订情况无跟进，时间一久理不清。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={four} alt='04' /></div>
            <h4>员工管理难</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s4']}></span>
            <p>
            工作进度靠各个员工主动汇报，难以将项目进度与员工工作进度对应。
            </p>
          </div>
        </li>
      </ul>
      <img src={solutions} alt='solutions' className={styles['solutions']} />
      <img src={circular} alt='circular' className={styles['circular']} />
    </div>
    <div className={styles['scheme']}>
      <h3>解决方法</h3>
      <p className={styles['scheme-wz']}>建新账，清旧账，理乱账，定制专属财税方案。</p>
      <div className={styles['scheme_content']}>
        <img src={operation_1} alt='operation_1' className={styles['gather']} />
        <div>
          <img src={one_x} alt='one-x' className={styles['one-x']} />
          <h4>智能客户管理</h4>
          <p>
          记录客户接洽事项以及成单情况，对客户的维护、授权、停止服务。
          </p>
        </div>
      </div>
      <div className={`${styles.scheme_content}`}>
        <div className={`${styles.scheme_two}`}>
          <img src={two_x} alt='two-x' className={styles['two-x']} />
          <h4>财税服务及工商服务协同</h4>
          <p>
            对客户工商服务等进行事项的指派和跟进。
          </p>
        </div>
        <img src={operation_2} alt='operation-2' className={styles['fetch']} />
      </div>
      <div className={styles['scheme_content']}>
        <img src={operation_3} alt='operation-2' className={styles['print']} />
        <div className={`${styles.scheme_three}`}>
          <img src={three_x} alt='three-x' className={styles['three-x']} />
          <h4>客户分析、合同统计及欠费通知</h4>
          <p>
          对客户账务数据进行分析与筛选；对客户合同签订、收费进行管理；欠费客户通知提示。
          </p>
        </div>
      </div>
      <div className={styles['scheme_content']}>
        <div className={`${styles.scheme_fous}`}>
          <img src={fous_x} alt='fous-x' className={styles['fous-x']} />
          <h4>员工工作进度一目了然</h4>
          <p>
          系统内随时可查询客户代账进度与员工做账进度，并对做账质量批量检查。
          </p>
        </div>
        <img src={operation_4} alt='operation_4' className={styles['ticket']} />
      </div>
    </div>
  </section>
}

export default Operation
